<template>
    <div class="categories">
        <div class="columns">
            <div class="column is-full">
                <div class="columns is-multiline" v-if="currentStep === 'Unterkonstruktion'"> 
                    <div class="column is-full">
                        <h2 class="has-text-primary is-size-3 is-uppercase">Für welche Unterkonstruktion wird die Schraube verwendet ...</h2>
                    </div>
                    <div class="column is-clickable" @click="selectCategory('categoryUnterkonstruktion', cat, 'Unterkonstruktion')" v-for="(cat, index) in categoryUnterkonstruktion" :key="index">
                        <div class="cat-box is-uppercase" :class="cat.isSelected ? 'has-background-green' : 'has-background-grey-light'">
                            <img class="has-icon" v-if="cat.isSelected" :src="getCategoryImageWhite(cat.name)"/>
                            <img class="has-icon" v-else :src="getCategoryImage(cat.name)"/>
                            <p class="bigger-text">{{ cat.name }}</p>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline" v-if="currentStep === 'Material'">
                    <div class="column is-full">
                        <h2 class="has-text-primary is-size-3 is-uppercase">Bitte wählen Sie das Material</h2>
                    </div>
                    <div class="column is-clickable" @click="selectCategory('categoryMaterial', cat, 'Material')" v-for="(cat, index) in categoryMaterial" :key="index">
                        <div class=" cat-box is-uppercase" :class="[(cat.isSelected ? 'has-background-green' : 'has-background-grey-light')]" >
                            <p class="bigger-text">{{ cat.name }}</p>
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline" v-if="currentStep === 'Schraubenart'">
                    <div class="column is-full">
                        <h2 class="has-text-primary is-size-3 is-uppercase">Bitte wählen Sie die Schraubenart</h2>
                    </div>
                    <div class="column is-4 is-clickable" align="center" @click="selectCategory('categorySchraubenart', cat, 'Schraubenart')" v-for="(cat, index) in categorySchraubenart" :key="index">
                        <div class="cat-box is-on-top" :class="cat.isSelected ? 'has-background-green' : 'has-background-grey-light'">
                            <div class="last-step-boxes">
                                <h3 class="is-uppercase is-size-4 category-name" v-if="cat.name === 'sandwichprofile'">Bohrschrauben und Befestiger für Sandwichprofile</h3>
                                <h3 class="is-uppercase is-size-5 category-name">{{ cat.name }}</h3>
                                <div class="is-uppercase" v-for="(catMaterial, index) in categoryMaterial" :key="index">
                                    <div v-if="catMaterial.id === 21 && catMaterial.isSelected && cat.id === 25">
                                        <div class="columns">
                                            <div class="column">
                                                <div class="sub-title">Schneidschrauben</div>
                                                <div class="content">
                                                    <div>E-X A Ø 6,5</div>
                                                    <div>E-X BZ Ø 6,3</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="catMaterial.id === 21 && catMaterial.isSelected && cat.id === 367">
                                        <div class="columns">
                                            <div class="column">
                                                <div class="sub-title">Bohrschrauben</div>
                                                <div class="content">
                                                    <div>E-X BR RS (REDUZIERTE SPITZE)</div>
                                                    <div>E-X BOHR 2</div>
                                                    <div>E-X BOHR 3</div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="sub-title">Sandwichbefestiger (HT-Schrauben)</div>
                                                <div class="content">
                                                    <div>E-X BOHR RS HT</div>
                                                    <div>E-X BOHR 3 HT</div>
                                                    <div>E-X BOHR 5 HT</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="catMaterial.id === 21 && catMaterial.isSelected && cat.id === 368">
                                        <div class="columns">
                                            <div class="column">
                                                <div class="sub-title">Sonderschrauben</div>
                                                <div class="content">
                                                    <div>E-X BOHR 3 LFT</div>
                                                    <div>E-X BOHR 5 LFT</div>
                                                    <div>E-X DDBS 3</div>
                                                    <div>E-X DDBS A</div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="sub-title">Gerüstankerschrauben</div>
                                                <div class="content">
                                                    <div>EGA E-X A</div>
                                                    <div>EGA EX BZ</div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="sub-title">Reparaturschrauben</div>
                                                <div class="content">
                                                    <div>E-XR AB Ø 7.2mm</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="catMaterial.id === 22 && catMaterial.isSelected && cat.id === 25">
                                        <div class="columns">
                                            <div class="column">
                                                <div class="sub-title">Schneidschrauben</div>
                                                <div class="content">
                                                    <div>E-VS A Ø 6,5</div>
                                                    <div>E-VS 8 A Ø 6,5 S.P.</div>
                                                    <div>E-VS BZ Ø 6,3</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="catMaterial.id === 22 && catMaterial.isSelected && cat.id === 367">
                                        <div class="columns">
                                            <div class="column">
                                                <div class="sub-title">Bohrschrauben</div>
                                                <div class="content">
                                                    <div>E-VS BOHR RS (reduzierte Spitze, Überlappungsschraube)</div>
                                                    <div>E-VS BOHR RS (reduzierte Spitze, für Holz-UK)</div>
                                                    <div>E-VS BOHR 3</div>
                                                    <div>E-VS BOHR 5</div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="sub-title">Sandwichbefestiger (HT-Schrauben)</div>
                                                <div class="content">
                                                    <div>E-VS BOHR RS HT</div>
                                                    <div>E-VS BOHR 3 HT</div>
                                                    <div>E-VS BOHR 5 HT</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="catMaterial.id === 22 && catMaterial.isSelected && cat.id === 368">
                                        <div class="columns">
                                            <div class="column">
                                                <div class="sub-title">Sonderschrauben</div>
                                                <div class="content">
                                                    <div>E-VS BOHR 2 FLT</div>
                                                    <div>E-VS BOHR 3 FLT</div>
                                                    <div>E-VS BOHR 5 FLT</div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="sub-title">Dachdeckerbohrschrauben</div>
                                                <div class="content">
                                                    <div>DDBS A</div>
                                                    <div>DDBS 3</div>
                                                    <div>DDBS 5</div>
                                                </div>
                                            </div>
                                            <div class="column">
                                                <div class="sub-title">Dachbauschrauben</div>
                                                <div class="content">
                                                    <div>E-DB RS TK</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loadingActive: false
        }
    },
    computed: {
        currentStep: {
            set (val) {
                this.$store.commit('setCurrentStep', val)
            },
            get () {
                return this.$store.state.currentStep
            }
        },
        categories () {
            return this.$store.state.categories
        },
        categoryUnterkonstruktion () {
            let collection = this.categories.filter(cat => cat.parent === this.categoryIdUnterkonstruktion)
            if (collection && collection[0]) {
                collection[0].isSelected = true
                this.$store.commit(`setCatIdUnterkonstruktion`, collection[0].id)
            }
            return collection
        },
        categoryMaterial () {
          let collection = this.categories.filter(cat => cat.parent === this.categoryIdMaterial)
            if (collection && collection[0]) {
                collection[0].isSelected = true
                this.$store.commit(`setCatIdMaterial`, collection[0].id)
            }
            return collection
        },
        categorySchraubenart () {
         let collection = this.categories.filter(cat => cat.parent === this.categoryIdSchraubenart)
            if (collection && collection[0]) {
                collection[0].isSelected = true
                this.$store.commit(`setCatIdSchraubenart`, collection[0].id)
            }
            return collection
        }
    },
    methods: {
        selectCategory(categoryKind, category, categoryType) {
            this[categoryKind].forEach(cat => {
                cat.isSelected = false
            })
            category.isSelected = true

            this.$store.commit(`setCatId${categoryType}`, category.id)
        },
        setCatIdUnterkonstruktion (catId) {
            this.$store.commit('setCatIdUnterkonstruktion', catId)
        },
        setCatIdMaterial (catId) {
            this.$store.commit('setCatIdMaterial', catId)
        },
        setCatIdSchraubenart (catId) {
            this.$store.commit('setCatIdSchraubenart', catId)
        },
        getCategoryImage(catName) {
            return require(`@/assets/images/${catName}.svg`)
        },
        getCategoryImageWhite(catName) {
            return require(`@/assets/images/${catName}_weiss.svg`)
        },
        isActive() {
            this.cat.isSelected = !this.cat.isSelected
        },
        loadingEffect () {
            setTimeout(() => {this.loadingActive = !this.loadingActive},2000)
        }
    }
}
</script>

<style lang="sass">
@import "../assets/sass/main.sass"

.has-icon
    width: 146px
    height: 117px

.circles
    font-size: 12px
    margin-top: -10px
    color: $primary
    padding-top: 2px
    width: 30px
    height: 30px
    border-radius: 50%
    align-items: center
    background-color: $grey-lighter
    font-weight: 700
    border-color: $grey-light
    border-style: solid

.description
    padding: 0 10px 0 10px

.description-title
    text-transform: uppercase

.last-step-boxes
    width: 100%

.category-name
    padding: 20px 0

.bigger-text
    font-size: 40px

.big-text
    font-size: 30px

.sub-title
    padding: 10px 0

.content
    font-size: 13px

</style>